"use client";
import React from "react";
import Image from "next/image";
import dynamic from "next/dynamic";
const RequestForm = dynamic(() => import("./form"));

import "swiper/css";
import "swiper/css/effect-fade";
import "swiper/css/pagination";

const MakePayment: React.FC = () => {
  return (
    <section>
      {/* Banner Section */}
      <div className="request-proposal-banner bg-background-dark  py-[120px] lg:py-[150px] xl:pb-[240px]  relative z-0">
        {/* Shapes */}
        <div className="banner-shape-1 absolute top-[0px] left-0 z-[1] w-[50%] md:w-[40%]">
          <Image
            src="/images/banner-left-layer-mobile.png"
            alt="Banner Shape"
            width={571}
            height={571}
            className="w-full h-full md:hidden"
          />
          <Image
            src="/images/banner-left-layer-tablet.png"
            alt="Banner Shape"
            width={571}
            height={571}
            className="w-full h-full hidden md:block lg:hidden"
          />
          <Image
            src="/images/banner-left-layer-desktop.png"
            alt="Banner Shape"
            width={571}
            height={571}
            className="w-full h-full hidden lg:block"
          />
        </div>
        <div className="banner-shape-1 absolute bottom-0 right-0 z-[-1] ">
          <Image
            src="/images/banner-right-layer-mobile.png"
            alt="Banner Shape"
            width={471}
            height={471}
            className="object-cover w-full h-full md:hidden"
          />
          <Image
            src="/images/banner-right-layer-tablet.png"
            alt="Banner Shape"
            width={471}
            height={471}
            className="object-cover w-full h-full hidden md:block lg:hidden"
          />
          <Image
            src="/images/banner-right-layer-desktop.png"
            alt="Banner Shape"
            width={471}
            height={471}
            className="object-cover w-full h-full hidden lg:block"
          />
        </div>
        <div className="container lg:p-[0px_24px]!">
          <div>
            <h1 className="text-white text-[28px] xm:text-[36px] lg:text-[56px] xl:text-[72px] xl:leading-[92px] lg:leading-[72px] xm:leading-[46.8px]  font-extrabold text-center uppercase">
              Make A Payment
            </h1>
            <p className="text-gray-50 text-subtitle-3 text-center mt-4 font-regular">
              We offer multiple modes of payment. You can pay at your
              convenience.
            </p>
          </div>
        </div>
      </div>

      {/* Form + Slider Section */}
      <div className="pb-[50px] md:pb-[80px] xl:pb-[100px] mt-[-100px] xl:mt-[-200px] relative z-0">
        <div className="container">
          <div className="grid grid-cols-1 lg:grid-cols-[30%_70%] xl:grid-cols-[30%_70%] gap-[30px]">
            {/* Left Slider */}
            <div className="left-div relative order-2 lg:order-0">
              {/* Keen Slider Container */}
              <div className="relative h-full overflow-hidden ">
                <div className="middle-div relative bg-white z-[0] min-h-[550px] sm:min-h-[550px] lg:min-h-[600px]">
                  <div className="top-layer absolute top-0 z-[-1] w-full h-[100%] lg:h-[60%] xl:h-[90%] ">
                    <Image
                      src="/images/hero-layer-top.png"
                      alt="Top Layer"
                      width={1000}
                      height={1000}
                      className="object-cover w-full h-[90%] xl:h-[80%]"
                    />
                  </div>

                  <div className="px-[16px] sm:px-[30px] lg:px-[16px] xl:px-[24px] pt-[100px] xl:pt-[100px] relative z-10">
                    <h2 className="text-center text-[22px] md:text-[24px] xl:text-[32px] font-[700] mb-[12px]">
                      Payment Options
                    </h2>
                    <p className="text-center text-[18px] xl:text-[20px] text-[#040405]">
                      You can pay the way you want
                    </p>
                  </div>
                  <div className="mt-[50px] md:mt-[60px] xl:mt-[100px] 2xl:mt-[125px] ">
                    <Image
                      src="/images/paypal-image.png"
                      alt="Step 3"
                      width={258}
                      height={140}
                      className=" xl:w-[258px] xl:h-[140px] w-[200px] h-[120px] object-contain mx-auto"
                    />
                  </div>
                </div>
                <div className="bottom-layer absolute bottom-0 z-[1] w-full h-[50%] sm:h-[70%] lg:h-[50%]">
                  <Image
                    src="/images/hero-layer-bottm.png"
                    alt="Step 3"
                    width={1000}
                    height={1000}
                    className="w-full h-full object-cover"
                  />
                </div>

                <div className="relative p-[0px_20px] xl:p-[0px_40px] lg:p-[0px_16px] bottom-[130px] xl:bottom-[50px]">
                  <p className="text-center text-subtitle-4 font-regular">
                    TRooInbound® is registered brand of TRooTech Business
                    Solutions Private Limited
                  </p>
                </div>
              </div>
            </div>
            <div className="right-div flex items-center h-full order-1 lg:order-2 w-full">
              <div className="h-full w-full">
                <RequestForm />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MakePayment;
